import React from 'react';
import Navbar from '../../components/general/Navbar';
import NotFound from '../../components/general/NotFound';
import Footer from '../../components/general/Footer';

const NotFoundPage = () => {
  return (
    <>
      <Navbar />
      <NotFound />
      <Footer />
    </>
  );
};

export default NotFoundPage;